import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
    GridList,
    GridTile,
} from 'material-ui/GridList';

import {
    subeventoService,
    categoriaService,
    areaService,
    eixoService,
    tipoSubmissaoService,
    projetoService,
    autorService,
    arquivoService,
    projetosNotaFinalService,
    tipoApresentacaoService,
    salaService,
    Utils,
} from '../../services';
import logoBoleto from '../../assets/boleto.png';
import logoCartao from '../../assets/cartao.png';
import logoDesclassificado from '../../assets/desclassificado.png';
import logoPago from '../../assets/pago.png';
import aprovado from '../../assets/aprovado.jpg';
import reprovado from '../../assets/reprovado.jpg';
import ok from '../../assets/ok.png';
import nao from '../../assets/X.png';
import {
    Load,
    ItemInformacoesInscricao,
} from '../../components';


const InformacoesPagamento = ({ projeto }) => {
    if (projeto.PAGO) {
        return (
            <img src={logoPago} alt="Logo Pago" />
        );
    } else if (projeto.NOSSONUMERO) {
        if (projeto.LINKBOLETO) {
            return (
                <a href={projeto.LINKBOLETO} target="_blank" rel="noopener noreferrer">
                    <img style={{ height: 48 }} src={logoBoleto} alt="Logo boleto" />
                    <br />
                    <span style={{ fontSize: 16 }}>Clique para gerar o boleto</span>
                </a>
            );
        }
        return (
            <div>
                <img style={{ height: 48 }} src={logoCartao} alt="Logo cartão" />
                <span style={{ fontSize: 16 }}>Aguardando aprovação...</span>
            </div>
        );
    }
    return (
        <span>Aguardando o aceito dos termos para iniciar etapa de pagamento.</span>
    );
};

InformacoesPagamento.propTypes = {
    projeto: PropTypes.shape({
        PAGO: PropTypes.bool,
        NOSSONUMERO: PropTypes.string,
        LINKBOLETO: PropTypes.string,
    }).isRequired,
};

const InformacoesStatus = ({ projeto }) => {
    if (projeto.EXCLUIDO) {
        return (
            <img style={{ height: 50 }} src={logoDesclassificado} alt="Logo Desclassificado" />
        );
    }
    return null;
};

InformacoesStatus.propTypes = {
    projeto: PropTypes.shape({
        EXCLUIDO: PropTypes.bool,
    }).isRequired,
};

const InformacoesApresentacao = ({
    sTeveAvaliacao, sAprovado, sApresentacao, sSala, sData, sInicio
}) => {
    if (!sTeveAvaliacao) { return null; }


    if (sAprovado && sSala !== '--') {
        return (
            <div style={{ fontSize: 30, color: '#268c4b' }}>
                <img style={{ height: 100 }} src={aprovado} alt="Aprovado" />
                <div>
                    para apresentação na modalidade <strong>{sApresentacao}</strong> no(a) {sSala} no dia {sData} às {sInicio}
                </div>
            </div>
        );
    } else
        if (sAprovado) {
            return (
                <div style={{ fontSize: 30, color: '#268c4b' }}>
                    <img style={{ height: 100 }} src={aprovado} alt="Aprovado" />
                    <div>
                        para apresentação na modalidade <strong>{sApresentacao}</strong>
                    </div>
                </div>
            );
        } else
            if (sAprovado === false) {
                return (
                    <div style={{ fontSize: 30, color: '#e21b1b' }}>
                        <img style={{ height: 100 }} src={reprovado} alt="Aprovado" />
                    </div>
                );
            }
    return null;
};

class InscricaoDetalhes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            carregando: true,
            nomeEvento: '',
            nomeSubevento: '',
            nomeCategoria: '',
            nomeArea: '',
            nomeEixo: '',
            nomeTipoSubmissao: '',
            titulo: '',
            autores: [],
            instituicao: '',
            arquivo: '',
            projeto: '',
            subeventoSelecionado: 0,
        };
    }

    async componentWillMount() {
        const { codigoProjeto } = this.props;

        if (codigoProjeto) {
            const projetoPromise = projetoService.getProjeto(codigoProjeto);
            const autoresPromise = autorService.getAutores(codigoProjeto);
            const [
                projeto,
                autoresProjeto,
            ] = await Promise.all([projetoPromise, autoresPromise]);

            this.setState({
                carregando: false,
                titulo: projeto.TITULO,
                nomeEvento: projeto.NOMEEVENTO,
                subeventoSelecionado: projeto.SUBEVENTOS_CODIGO,
                nomeSubevento: projeto.NOMESUBEVENTO,
                nomeCategoria: projeto.NOMECATEGORIA,
                nomeArea: projeto.NOMEAREA,
                nomeEixo: projeto.NOMEEIXO,
                nomeTipoSubmissao: projeto.NOMETIPOSUBMISSAO,
                instituicao: projeto.INSTITUICAO,
                autores: autoresProjeto,
                arquivo: await arquivoService.getLinkArquivo(codigoProjeto),
                projeto,
            });
        } else {
            const {
                titulo,
                instituicao,
                autores,
            } = this.props.detalhesInscricao;
            const [
                subevento,
                categoria,
                area,
                eixo,
                tipoSubmissao,
            ] = await this.getDetalhesInscricao();

            this.setState({
                carregando: false,
                titulo,
                nomeEvento: subevento.NOMEEVENTO,
                nomeSubevento: subevento.NOME,
                nomeCategoria: categoria.NOME,
                nomeArea: area.NOME,
                nomeEixo: eixo.NOME,
                nomeTipoSubmissao: tipoSubmissao.DESCRICAO,
                instituicao,
                autores,
            });
        }
        this.getInfoAprovacao(codigoProjeto);
    }

    getDetalhesInscricao() {
        const subevento = subeventoService.getSubeventoPublico(this.props.detalhesInscricao.subevento);
        const categoria = categoriaService.getCategoria(this.props.detalhesInscricao.categoria);
        const area = areaService.getArea(this.props.detalhesInscricao.area);
        const eixo = eixoService.getEixo(this.props.detalhesInscricao.eixo);
        const tipoSubmissao = tipoSubmissaoService.getTipoSubmissao(this.props.detalhesInscricao.tipo);
        return Promise.all([subevento, categoria, area, eixo, tipoSubmissao]);
    }

    async getInfoAprovacao(codigoProjeto) {
        if (codigoProjeto) {
            const nota = await projetosNotaFinalService.getNotadoProjeto(codigoProjeto);

            if (nota.length === 0) {
                // não monta a tabelinha
                this.setState({
                    sTeveAvaliacao: false,
                    sAprovado: false,
                    sApresentacao: '--',
                    sSala: '--',
                    sData: '--',
                    sInicio: '--',
                });
            } else {
                // segue o baile aqui
                // busca se tá aprovado e a modalidade
                const tipoApresentacao = await tipoApresentacaoService.getTipoApresentacao(codigoProjeto);
                if (tipoApresentacao.length > 0) {
                    this.setState({
                        sTeveAvaliacao: true,
                        sAprovado: !!tipoApresentacao[0].APROVADO,
                        sApresentacao: tipoApresentacao[0].MODALIDADE,
                    });
                } else {
                    this.setState({
                        sTeveAvaliacao: true,
                        sAprovado: false,
                        sApresentacao: '--',
                    });
                }
                // sala de apresentação
                const sala = await salaService.getSalasApresentacao(codigoProjeto);
                if (sala.length > 0) {
                    const dataCerta = Utils.getFormatDate(sala[0].DATAAPRESENTACAO);
                    const horaCerta = Utils.getFormatHora(sala[0].HORAINICIO);

                    this.setState({
                        sSala: sala[0].NOME,
                        sData: dataCerta,
                        sInicio: horaCerta,
                    });
                } else {
                    this.setState({
                        sSala: '--',
                        sData: '--',
                        sInicio: '--',
                    });
                }
            }
        }
    }

    async irParaPaginaInicial() {
        window.location.href = '/inscricao';
    }

    render() {
        const {
            titulo,
            instituicao,
            carregando,
            nomeEvento,
            nomeSubevento,
            nomeCategoria,
            nomeArea,
            nomeEixo,
            nomeTipoSubmissao,
            projeto,
            autores,
            arquivo,
            sAprovado,
            sApresentacao,
            sSala,
            sData,
            sInicio,
            sTeveAvaliacao,
        } = this.state;
        const {
            codigoProjeto,
        } = this.props;

        return (
            <div>
                {
                    carregando ?
                        <Load /> :
                        <div className="padding-content">
                            <div style={{ marginTop: 16, textAlign: 'center' }}>
                                <ItemInformacoesInscricao texto={nomeEvento} cor="#DE1F1FCC" />
                                <ItemInformacoesInscricao texto={nomeSubevento} cor="#4F805B" />
                                <ItemInformacoesInscricao texto={nomeCategoria} cor="#F37B26" />
                                <ItemInformacoesInscricao texto={nomeArea} cor="#555" />
                                <ItemInformacoesInscricao texto={nomeEixo} cor="#42B1EF" />
                                <ItemInformacoesInscricao texto={nomeTipoSubmissao} cor="#96695C" />
                            </div>
                            <GridList cols={3} cellHeight="auto">
                                <GridTile cols={3} style={{ textAlign: 'center' }}>
                                    <h2>{titulo}</h2>
                                </GridTile>
                                {
                                    codigoProjeto ?
                                        <GridTile cols={3} style={{ textAlign: 'center' }}>
                                            <InformacoesStatus projeto={projeto} />
                                        </GridTile>
                                        : <span />
                                }
                                {
                                    codigoProjeto ?
                                        <GridTile cols={3} style={{ textAlign: 'center' }}>
                                            <InformacoesApresentacao sTeveAvaliacao={sTeveAvaliacao} sAprovado={sAprovado} sApresentacao={sApresentacao} sSala={sSala} sData={sData} sInicio={sInicio} />
                                        </GridTile>
                                        : <span />
                                }
                                <GridTile cols={1.5} style={{ textAlign: 'center', padding: 8 }}>
                                    <h3>Pagamento</h3>
                                    {
                                        codigoProjeto ?
                                            <InformacoesPagamento projeto={projeto} /> :
                                            <span>Aguardando finalização da inscrição.</span>
                                    }
                                </GridTile>
                                <GridTile cols={1.5} style={{ textAlign: 'center', padding: 8 }}>
                                    <h3>Instituição</h3>
                                    {instituicao}
                                </GridTile>

                                <GridTile cols={1.5} style={{ textAlign: 'center', padding: 8 }}>
                                    <h3>Autor(es)</h3>
                                    {
                                        // eslint-disable-next-line react/no-array-index-key
                                        autores.map((x, index) => <div key={index}>{x.NOME} {x.ORIENTADOR ? ' (O)' : ' (A)'}</div>)
                                    }
                                </GridTile>
                                <GridTile cols={1.5} style={{ textAlign: 'center', padding: 8 }}>
                                    <h3>Aceitou Termo</h3>
                                    {
                                        // eslint-disable-next-line react/no-array-index-key
                                        autores.map((x, index) => <div key={index}>{x.ACEITOUTERMO ? <img style={{ height: 20 }} src={ok} /> : <img style={{ height: 16 }} src={nao} />} {x.NOME} {x.ORIENTADOR ? ' (O)' : ' (A)'}</div>)
                                    }
                                </GridTile>
                                {
                                    codigoProjeto ?
                                        <GridTile cols={3} style={{ height: 700 }}>
                                            <iframe style={{ marginTop: 16 }} src={arquivo} height="700px" width="100%" title="Arquivo enviado" frameBorder="0" />
                                        </GridTile> :
                                        <div />
                                }
                            </GridList>
                        </div>
                }
            </div>
        );
    }
}

InscricaoDetalhes.defaultProps = {
    detalhesInscricao: {},
    codigoProjeto: '',
};

InscricaoDetalhes.propTypes = {
    detalhesInscricao: PropTypes.shape({
        evento: PropTypes.number,
        eixo: PropTypes.number,
        area: PropTypes.number,
        subevento: PropTypes.number,
        categoria: PropTypes.number,
        titulo: PropTypes.string,
        instituicao: PropTypes.string,
        tipo: PropTypes.number,
        autores: PropTypes.array,
    }),
    codigoProjeto: PropTypes.string,
};

export default withRouter(InscricaoDetalhes);
